/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const Header = (props) => {

    const [windFlag, setWindFlag] = useState(null)
    const [capFlag, setCapFlag] = useState(null)
    const [outputFlag, setOutputFlag] = useState(null)
    const [windChange, setWindChange] = useState(null)
    const [capChange, setCapChange] = useState(null)
    const [outputChange, setOutputChange] = useState(null)

    useEffect( () => {
        console.log('props in header',props)
        let u = calc_perc_change(props.state.output0,props.state.output)
        setOutputChange(u[0])
        setOutputFlag(u[1])

        u = calc_perc_change(props.state.capacity0,props.state.capacity)
        setCapChange(u[0])
        setCapFlag(u[1])

        u = calc_perc_change(props.state.wind0,props.state.wind)
        setWindChange(u[0])
        setWindFlag(u[1])

    }, [props])

    // useEffect(()=>{
    //     console.log('windChange',props.state.wind0,props.state.wind,windChange)
    // },[windChange])

    
  return (
    <>
      <div className="header bg-gradient-default pb-8 pt-1 pt-md-1" >
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row style={{ marginTop:0}}>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Number of Projects
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {props.num_sites}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          {/* <i className="fas fa-chart-bar" /> */}
                          <i className="fa-solid fa-magnifying-glass-location"></i>
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-nowrap" style={{color:'white'}}>Since last month</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Total Output
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{Math.round(props.state.output).toLocaleString() } MW</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          {/* <i className="fas fa-chart-pie" /> */}
                          <i className="fa-solid fa-bolt"></i>
                        </div>
                      </Col>
                    </Row>
                    {outputChange?
                        <p className="mt-3 mb-0 text-muted text-sm">
                        {outputFlag==true?
                          <span className="text-success mr-2">
                              <i className="fas fa-arrow-up" /> {Math.round(outputChange/100*props.state.output0)} MW ({Math.round(outputChange)}%)
                          </span>:
                          <span className="text-danger mr-2">
                              <i className="fas fa-arrow-down" /> {Math.round(outputChange/100*props.state.output0)} MW ({Math.round(outputChange)}%)
                          </span>}{" "}
                          <span className="text-nowrap">Since yesterday</span>
                        </p>:null}
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Average Net Capacity Factor
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{Math.round(props.state.capacity*1000)/10}%</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                          {/* <i className="fas fa-users" /> */}
                          <i className="fa-solid fa-battery-three-quarters"></i>
                        </div>
                      </Col>
                    </Row>
                    {capChange?
                        <p className="mt-3 mb-0 text-muted text-sm">
                        {capFlag==true?
                          <span className="text-success mr-2">
                              <i className="fas fa-arrow-up" /> {Math.round((props.state.capacity-props.state.capacity0)*1000)/10}%
                          </span>:
                          <span className="text-danger mr-2">
                              <i className="fas fa-arrow-down" /> {Math.round((props.state.capacity0-props.state.capacity)*1000)/10}%
                          </span>}{" "}
                          <span className="text-nowrap">Since yesterday</span>
                        </p>:null}
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Average Wind Speed (150 m)
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{Math.round(props.state.wind*10)/10} m/s</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          {/* <i className="fas fa-percent" /> */}
                          <i className="fa-solid fa-wind"></i>
                        </div>
                      </Col>
                    </Row>
                    {windChange?
                        <p className="mt-3 mb-0 text-muted text-sm">
                        {windFlag==true?
                          <span className="text-success mr-2">
                              <i className="fas fa-arrow-up" /> {Math.round((props.state.wind-props.state.wind0)*10)/10} m/s ({Math.round(windChange)}%)
                          </span>:
                          <span className="text-danger mr-2">
                              <i className="fas fa-arrow-down" /> {Math.round((props.state.wind0-props.state.wind)*10)/10} m/s ({Math.round(windChange)}%)
                          </span>}{" "}
                          <span className="text-nowrap">Since yesterday</span>
                        </p>:null}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;

function calc_perc_change(orig_num,new_num){
    if(new_num>=orig_num) {
        return [(new_num-orig_num)/orig_num *100, true]
    }else{
        return [(orig_num-new_num)/orig_num*100, false]
    } 
}
